const config = {
    currentTableData: {
        currentList: []
    },
    keycloakState: {
        keycloakAuthenticated: false,
        keycloakReady: false
    },
    routes: [
        {id: 'dashboard', needsAuth: false}
    ],
    tokensDefault: {
        idToken: null,
        token: null,
        refreshToken: null,
        timeSkew: 0
    },
    urls: {
        api_url: ''
    }
};

export default config;
